import { createRouter, createWebHistory } from 'vue-router';
import PayCenter from '../views/PayCenter.vue';
import VipCenter from '../views/VipCenter.vue';

const routes = [
  {
    path: '/',
    redirect: '/pay-center'
  },
  {
    path: '/pay-center',
    name: 'PayCenter',
    component: PayCenter,
    meta: {
      title: 'CITY OF CRIME Official Pay Center',
    },
  },
  {
    path: '/vip-center',
    name: 'VipCenter',
    component: VipCenter,
    meta: {
      title: 'CITY OF CRIME Official VIP Center',
    },
  },
  {
    path: '/deepgrow/mockpayment',
    name: 'MockPayment',
    component: () => import('../views/MockPayment.vue'),
    meta: {
      title: 'DeepGrow Mock Payment',
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// 路由守卫：设置页面标题
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

export default router;